import React, { useEffect } from "react";
import NavigationHeader from "../NavigationHeader/NavigationHeader";
import TopMenuV2 from "../TopMenu/TopMenuV2";
import ShoppingCart from "../ShopList/ShoppingCartList";
import { isObject } from "../../utils/ObjectCheck";
import { useSelector, useDispatch } from "react-redux";
import "./home.css";
import { useOrderConfirm } from "./useOrderConfirm";
import { setSelectedMenuType } from "../../yoello-lib/modules/redux/actions/consumer.actions";

export function MenuContainer({ area, openSideDrawer, ...props }) {
  const Venue = useSelector((state: any) => state.Venue);
  const groupName = useSelector((state: any) => state.GroupName);
  const SelectedMenuType = useSelector((state: any) => state.SelectedMenuType);
  const dispatch = useDispatch();
  useOrderConfirm(props.openSettingsPage);
  useEffect(() => {
    /**If a user goes to the menu page before coming here push them back */
    if (props.match.params["id"] !== Venue.venue_nickname) {
      props.history.push("/v/" + props.match.params["id"]);
    }

    // if there is no selected menu type then user should be sent back to venue page so he/she can pick one
    if (!SelectedMenuType && window.location.pathname.split("/")[1] !== "g") {
      props.history.push("/v/" + props.match.params["id"]);
    }
    // eslint-disable-next-line
  }, []);

  function goBack() {
    dispatch(setSelectedMenuType(null));
    props.history.push(getBackURL(Venue, groupName));
  }
  return (
    <div>
      <div className="Home" id="homeContainerId">
        <NavigationHeader openSideDrawer={openSideDrawer} backURL={goBack} />
        <div
          style={{
            marginTop: "6.7rem",
          }}
        >
          <TopMenuV2 />
        </div>
        <ShoppingCart area={area} canOnlyView={false} />
      </div>
    </div>
  );
}

function getBackURL(venue, groupName) {
  if (!isObject(venue, true)) {
    const pathNameSplit = window.location.pathname.split("/menu")[0];
    return pathNameSplit;
  }
  const windowSplit = window.location.pathname.split("/");
  if (windowSplit[1] === "g") {
    return `/g/${groupName}/${venue.venue_nickname}`;
  } else if (windowSplit[1] === "v") {
    /**IF you navigate to a new venues menu without going to the menu page, navigate back to the venue page */
    if (windowSplit[2] !== venue.venue_nickname) {
      return "/v/" + windowSplit[2];
    }
    return "/v/" + venue.venue_nickname;
  } else {
    return "/a/hayes-cardiff/" + venue.venue_nickname;
  }
}
